import request from '@/utils/request'
export function fetchList(data) {
  return request({
    url: '/paymentMethod/List',
    method: 'post',
    data,
  })
}

export function getItem(id) {
  return request({
    url: '/paymentMethod/Get',
    method: 'post',
    data: { id: id },
  })
}

export function createItem(data) {
  console.log('createItem', data)
  return request({
    url: '/paymentMethod/Create',
    method: 'post',
    data,
  })
}

export function updateItem(data) {
  console.log('updateItem', data)
  return request({
    url: '/paymentMethod/Update',
    method: 'post',
    data,
  })
}

export function deleteItem(data) {
  return request({
    url: '/paymentMethod/Delete',
    method: 'delete',
    data,
  })
}
